import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/interventions',
        component: () => import('@/pages/interventions/Interventions.vue'),
        name: 'interventions-home',
        meta: {
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) =>
                gateKeeper.userHasPermission('view all Interventions') ||
                gateKeeper.userHasGroupPermission('view all Interventions'),
        },
    },
];
